/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Architect_Output9Inputs */

const en_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent architecture diagram`)
};

const ar_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخطط معمارية الوكيل`)
};

const bn_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এজেন্ট আর্কিটেকচার ডায়াগ্রাম`)
};

const de_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagramm der Agentenarchitektur`)
};

const es_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagrama de arquitectura del agente`)
};

const fr_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schéma de l'architecture de l'agent`)
};

const pt_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagrama de arquitetura do agente`)
};

const zh_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理架构图`)
};

const tr_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aracı mimari diyagramı`)
};

const ru_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схема архитектуры агента`)
};

const pl_svc_ai_agent_development_architect_output9 = /** @type {(inputs: Svc_Ai_Agent_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram architektury agenta`)
};

/**
* | output |
* | --- |
* | "Agent architecture diagram" |
*
* @param {Svc_Ai_Agent_Development_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_architect_output9 = /** @type {((inputs?: Svc_Ai_Agent_Development_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "de") return de_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "es") return es_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_architect_output9(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_architect_output9(inputs)
	return en_svc_ai_agent_development_architect_output9(inputs)
});
export { svc_ai_agent_development_architect_output9 as "svc_ai-agent-development_ARCHITECT_output" }